import { Divider, FormControl, Grid, TextField } from "@mui/material";

import FilterLabel from "./utils/FilterLabel";
import FilterController from "./utils/FilterController";
import { LabelSharp } from "@mui/icons-material";

const CustomerFilters = ({ values, errors, handleChange, setValues , Labels }) => {
  return (
    <>
      <Grid item>
        <FormControl margin="dense" fullWidth>
          <FilterLabel sx={{ fontSize: 16 }}>Customer</FilterLabel>
        </FormControl>
      </Grid>
      <Grid item>
        <Grid container spacing={2}>
          <Grid item xs={2}>
            <FilterController label="ID Client" error={errors.customerClientId}>
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.customerClientId}
                value={values.customerClientId}
                onChange={handleChange}
                name="customerClientId"
              />
            </FilterController>
          </Grid>
          <Grid item xs={2}>
            <FilterController
              label="Account N&#176;"
              error={errors.customerAccountNumber}
            >
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.customerAccountNumber}
                value={values.customerAccountNumber}
                onChange={handleChange}
                name="customerAccountNumber"
              />
            </FilterController>
          </Grid>
          <Grid item xs={2}>
            <FilterController label="IBAN" error={errors.customerIban}>
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.customerIban}
                value={values.customerIban}
                onChange={handleChange}
                name="customerIban"
              />
            </FilterController>
          </Grid>
          <Grid item xs={2}>
            <FilterController label="BBAN" error={errors.customerBban}>
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.customerBban}
                value={values.customerBban}
                onChange={handleChange}
                name="customerBban"
              />
            </FilterController>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Grid container spacing={2}>
          <Grid item xs={2}>
            <FilterController
              label={Labels.customer50}
              error={errors.f50AOrderingCustomer}
            >
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.f50AOrderingCustomer}
                value={values.f50AOrderingCustomer}
                onChange={handleChange}
                name="f50AOrderingCustomer"
              />
            </FilterController>
          </Grid>
          <Grid item xs={2}>
            <FilterController
              label={Labels.customer59}
              error={errors.f59ABeneficiaryCustomer}
            >
              <TextField
                size="small"
                sx={{ background: "#fff" }}
                error={!!errors.f59ABeneficiaryCustomer}
                value={values.f59ABeneficiaryCustomer}
                onChange={handleChange}
                name="f59ABeneficiaryCustomer"
              />
            </FilterController>
          </Grid>
        </Grid>
      </Grid>
      <Grid item>
        <Divider />
      </Grid>
    </>
  );
};

export default CustomerFilters;
